import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NRetrieveIntelligenceApi = global.NRetrieveIntelligenceApi

class RetrieveIntelligenceApi extends Http {
  [x: string]: any

  // 取现情报列表
  public async getCashOutList(data: NRetrieveIntelligenceApi.CashOutListRequestData) {
    return await super.request<NRetrieveIntelligenceApi.CashOutListResponse>({
      url: '/crossbowSystem/cashOut/list',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  // 取现情报导出
  public async getCashOutExport(data: NRetrieveIntelligenceApi.CashOutListRequestData) {
    return await super.request<NRetrieveIntelligenceApi.CashOutListResponse>({
      url: '/crossbowSystem/cashOut/exportExcel',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data,
      responseType: 'blob'
    })
  }

  // 获取省市区数据
  public async getCityMapping() {
    return await super.request<NRetrieveIntelligenceApi.CityMappingResponse>({
      url: '/crossbowSystem/getCityMapping',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {}
    })
  }

  // 获取预警精度选项
  public async getAlertAccuracyOptions() {
    return await super.request<NRetrieveIntelligenceApi.AlertAccuracyOptionsResponse>({
      url: '/crossbowSystem/cashOut/getAlertAccuracyOptions',
      method: RequestType.Get,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {}
    })
  }
}

export default RetrieveIntelligenceApi
